class UserHelper {

    getCurrentUser() {
        return JSON.parse(localStorage.getItem('user'));
    }

    // Test user is admin or not
    isAdmin(user = this.getCurrentUser()) {
        if (user && (user["role"] == "superadmin" || user["role"] == "devel")) {
            return true;
        }
        return false;
    }

    // Test user is super operator or not
    isOperator(user = this.getCurrentUser()) {
        if (user && user["role"] == "superoperator") {
            return true;
        }
        return false;
    }

    // Test user is a client viewer or not
    isViewer(user = this.getCurrentUser()) {
        if (user && user["role"] == "clientviewer") {
            return true;
        }
        return false;
    }

    // Test user is a client normal user or not
    isClientUser(user = this.getCurrentUser()) {
        if (user && user["role"] == "clientoperator") {
            return true;
        }
        return false;
    }

    // Test user is a client admin or not
    isClientAdmin(user = this.getCurrentUser()) {
        if (user && user["role"] == "clientadmin") {
            return true;
        }
        return false;
    }

    // Get the user client ID or the chosen client ID to display if current user is admin
    getClientId(user = this.getCurrentUser()) {

        if (this.isAdmin(user) || this.isOperator(user)) {
            let clientId = JSON.parse(localStorage.getItem('clientIdToWatch'));
            // 0 => "Tous les clients" (pas de filtre)
            if (clientId === 0) return null;
            return Number.isInteger(clientId) ? clientId : null;
        }
        return user ? user["clientId"] : null;
    }

}

export default new UserHelper();